'use client';
import React from 'react';
import cn from './style.module.scss';
import {Box} from '@mui/material';
import WaldorfTeaserContainer from '../WaldorfContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
export default function WaldorfFooter(props: any) {
  const {t} = props;
  return (
    <Box component={'footer'} className={cn.waldorfFooterWrapper}>
      <WaldorfTeaserContainer>
        <Box component={'div'} className={cn.waldorfFooterInner}>
          <ParallaxText
            variant='h5'
            animationType='slideInBottom'
            animationDuration={800}>
            {ReactHtmlParser(t['waldorfFooterDeclaimerHeading'])}
          </ParallaxText>
          <ParallaxText
            variant='body1'
            animationType='slideInBottom'
            animationDuration={800}>
            {ReactHtmlParser(t['waldorfFooterDeclaimerContent'])}
          </ParallaxText>
        </Box>
      </WaldorfTeaserContainer>
    </Box>
  );
}
